(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "./index.less"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("./index.less"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.index);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _index) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('fieldset', {
        staticClass: "nx-field"
      }, [_c('div', {
        staticClass: "nx-field-content",
        class: _vm.leftTitleSizeClass
      }, [_vm._t("default")], 2)]);
    },
    name: 'nx-field',
    provide: function provide() {
      return {
        rootField: this
      };
    },
    data: function data() {
      return {
        fieldItems: []
      };
    },
    props: {
      leftWidth: {
        type: Boolean,
        default: true
      },
      leftTitleSize: {
        default: undefined
      },
      clickable: {
        default: undefined
      }
    },
    computed: {
      maxLeftWidth: function maxLeftWidth() {
        var list = this.fieldItems;
        var maxWidth = 0;
        list.forEach(function (item) {
          var _item$$refs;

          var itemLeft = (_item$$refs = item.$refs) === null || _item$$refs === void 0 ? void 0 : _item$$refs.fieldItemLeft;
          if (itemLeft && itemLeft.offsetWidth > maxWidth) maxWidth = itemLeft.offsetWidth;
        });
        return maxWidth;
      },
      leftTitleSizeClass: function leftTitleSizeClass() {
        var size = String(this.leftTitleSize);

        if (size === '42') {
          return 'nx-field-item__title-42';
        } else if (size === '48') {
          return 'nx-field-item__title-48';
        } else {
          return '';
        }
      }
    },
    methods: {
      $_add: function $_add(item) {
        if (!this.leftWidth) return;

        if (this.fieldItems.indexOf(item) === -1) {
          this.fieldItems.push(item);
        }
      },
      $_remove: function $_remove(item) {
        if (!this.leftWidth) return;
        var index = this.fieldItems.indexOf(item);

        if (index >= 0) {
          this.fieldItems.splice(index, 1);
        }
      }
    }
  };
  _exports.default = _default;
});